export const UNASSIGNED_USER_ID = -1;